export const QUESTION_TYPE = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  FREE_TEXT: 'FREE_TEXT',
};

export const AI_QUESTION_CARD_LABELS = {
  BACK: 'Back',
  SKIP: 'Skip',
  CONTINUE: 'Continue',
  SUBMIT: 'Submit answers',
  DISMISS: 'Dismiss',
  EDIT: 'Edit',
  ANSWERED_TRAIL_TITLE: 'Your answers',
  SKIPPED_SUMMARY: 'Skipped',
  FREE_TEXT_PLACEHOLDER: 'Type your answer',
};
